import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from 'react';

import LoadingComponent from '../../app/layout/LoadingComponent';
// import { ListDocentes } from '../../app/models/ListDocentes';

import { useStore } from '../../app/stores/store';
import { Icon } from 'semantic-ui-react'
import { Pagination } from 'semantic-ui-react';
import "./src/css/docentes.css"

import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';

import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { BsFillPersonFill } from "@react-icons/all-files/bs/BsFillPersonFill";
import { FaPhoneAlt } from "@react-icons/all-files/fa/FaPhoneAlt";
import { ImLocation } from "@react-icons/all-files/im/ImLocation";
import { BsSearch } from "@react-icons/all-files/bs/BsSearch";

import docentePlaceholder from "./src/imgs/docente_placeholder.png";

import Footer from '../Footer';
import { Link } from 'react-router-dom';
import DocenteCursos from "./DocenteCursos";

let paginas: number

export default observer(function ListaDocentes() {
    const { ListaDocentesStore } = useStore();
    const { loadListaDocentess, ListaDocentesRegistry, loadListaDocentesPagina, loadListaDocentesBusqueda } = ListaDocentesStore;
    const [activePage, setActivePage] = useState(1);
    const [pagina, setPagina] = useState(0);
    const [persona, setPersona] = useState("");

    useEffect(() => {
        loadListaDocentesPagina(activePage).then(() => {
            ListaDocentesStore.ListaDocentesByCodigo.map((item) => {
                paginas = item.recordsTotal % 12
                setPagina(paginas)
            })
        });
    }, [activePage]);

    function delegacion(valor: number) {
        if (valor = 1) {
            return ("INAP Central");
        }
        return ("Delegación Petén");
    }

    function cambioPagina(pagina: any) {
        setPersona("")
        setActivePage(pagina.activePage)
    }

    function buscarPersona() {
        var inputPersona = (document.getElementById("buscador") as HTMLInputElement).value
        loadListaDocentesBusqueda(inputPersona).then(() => {
            ListaDocentesStore.ListaDocentesByCodigo.map((item) => {
                paginas = item.recordsTotal % 12
                setPagina(paginas)
            })
            setActivePage(1)
        });

    }

    function AlertSinResultados() {
        const [show, setShow] = useState(true);

        if (show) {
            return (
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <p>
                        Actualmente no se encuentran docentes registrados con el número de DPI que has ingresado. <br></br>Intenta corroborar el número que has ingresado.
                    </p>
                </Alert>
            );
        }
        return <Button onClick={() => setShow(true)}>Show Alert</Button>;
    }

    if (ListaDocentesStore.loadingInitial) return <LoadingComponent content='Cargando datos..' />

    return (

        <>

            <Container className="lista-docentes-header">
                <Col xs="12" sm="8" className="info-box">
                    <h1>Docentes registrados</h1>
                    <p>Listado de docentes registrados, por favor si no encuentras el docente en el listado utiliza el buscador e ingresa el número de DPI correspondiente al docente.</p>
                </Col>
                <Col xs="12" sm="4" className="search-box">
                    <InputGroup>
                        <Form.Control
                            placeholder="Buscar por DPI (sin espacios)"
                            aria-label="Buscar por DPI (sin espacios)"
                            aria-describedby="buscador-docentes"
                        />
                        <Button variant="outline-secondary" id="button-addon2">
                            <BsSearch />
                        </Button>
                    </InputGroup>
                </Col>
            </Container>

            <Container className="lista-docentes-content">

                <Row >
                    <Col className="tarjeta-docente-area">

                        {ListaDocentesStore.ListaDocentesByCodigo.map((item) => {
                            if (item.records.length >= 1) {

                                
                                return (
                                    
                                    <>


                                        {item.records.map((docente) => {
                                            
                                            const docURL = "/docente/" + docente.guid;

                                            return (

                                            <Link to={docURL}>
                                                <Card className="tarjeta-docente">
                                                    <Container className="contender-tarjeta-docente">

                                                        <Row className="doc-title-area">
                                                            <Col sm={3} className="doc-image-area">
                                                                <Image src={docente?.urlImage || docentePlaceholder} roundedCircle></Image>
                                                            </Col>
                                                            <Col sm={9} className="doc-name-area">
                                                                <h4>{docente.fullName}</h4>
                                                            </Col>
                                                        </Row>

                                                        <Row className="doc-info-area">
                                                            <p><span>{<BsFillPersonFill />}</span>{docente.dpi}</p>
                                                            <p><span>{<FaPhoneAlt />}</span>{docente.telephone}</p>
                                                            <p><span>{<ImLocation />}</span>{delegacion(docente?.location)}</p>
                                                        </Row>

                                                    </Container>
                                                </Card>
                                            
                                            </Link>

                                            )
                                        })}

                                    </>

                                )
                            } else {

                                return (
                                    <AlertSinResultados />
                                )

                            }

                        })}


                    </Col>
                </Row>

                <div className="contenedor_paginacion_lista_docentes">
                    <div>
                        <Pagination
                            onPageChange={(event, data) => cambioPagina(data)}
                            defaultActivePage={activePage}
                            ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                            firstItem={null}
                            lastItem={null}
                            prevItem={{ content: <Icon name='angle left' />, icon: true }}
                            nextItem={{ content: <Icon name='angle right' />, icon: true }}
                            totalPages={pagina}
                        />
                    </div>
                </div>
            </Container>

            <Footer />
        </>


    )
})